/* eslint-disable max-len */
export default {
  title: 'We\'re sorry! The outage map is unavailable right now.',
  caption: 'Don\'t worry, you can find the outage summary report below. For more ways to stay informed about outages, please visit the Current Outages page. ',
  CTA: 'Current Outages'
};
